import insertYearBreakTrans from "./insert_year_break_trans";

export const calcTotalTranAmts =(tranArr, savingsClass) => {
    let totalTranAmt = 0;
    let totalShareQty = 0;
    let yearBreakArr = [];
    let currentTranYear = "";
    let previousTranYear = "";
    let previousTranDate = "";
    let monthlyTranAmt = 0;
    let monthlyShareQty = 0;
    let tranSort = "";
    let previousSharePrice = 0;
    let tranNbr = 1;
    let lastEntry = false;
    for (let i=0; i<tranArr.length; i++){
        currentTranYear = tranArr[i].tranDate.split('-')[0];
        if (currentTranYear !== previousTranYear && previousTranYear !== ""  ){
            //  need to handle whether tranYear or tranDate .....  
            insertYearBreakTrans(totalTranAmt, previousTranYear, savingsClass, totalShareQty, 
                tranSort, yearBreakArr, lastEntry);
        }
       
        if (tranArr[i].tranDate !== previousTranDate){
            if (previousTranDate !== ""){
                let tranObj = {tranType: "Monthly Total", 
                        tranDate: previousTranDate,
                        tranAmt: monthlyTranAmt,
                        tranNbr: 9996, 
                    };
                if (savingsClass === "retirement"){
                    tranObj.tranAmt = monthlyTranAmt;
                    tranObj = {...tranObj, sharePrice: "", shareQauntity: +monthlyShareQty}
                }
                yearBreakArr.push(tranObj);
            }
            previousTranDate = tranArr[i].tranDate;
            monthlyTranAmt = 0;
            monthlyShareQty = 0;
      
            if (tranArr[i].sharePrice){
                previousSharePrice = tranArr[i].sharePrice;
            }
          
        }
        if (tranArr[i].tranType === "Federal Income Tax" || 
            tranArr[i].tranType === "Federal Income Tax - Transfer" ){
                tranNbr = 9999;
        }else{
            tranNbr += 1;
            totalTranAmt += +tranArr[i].tranAmt;
            monthlyTranAmt += +tranArr[i].tranAmt;
            if (savingsClass === "retirement"){
                totalShareQty += +tranArr[i].shareQuantity;
                monthlyShareQty += +tranArr[i].shareQuantity;
            }
        }
        tranArr[i].tranNbr = tranNbr;
        previousTranYear = currentTranYear;
        tranSort = tranArr[i].tranSort;
    }
    if (savingsClass === "retirement"){
        monthlyTranAmt = +monthlyShareQty * previousSharePrice;
    }
    totalShareQty = totalShareQty.toFixed(4);
   
    let tranObj = {tranType: "Monthly Total", 
                tranDate: previousTranDate,
                tranAmt: monthlyTranAmt,
                tranNbr: 9996, 
            };
    if (savingsClass === "retirement"){
        tranObj.tranAmt = (+previousSharePrice * +monthlyShareQty).toFixed(2);
        tranObj = {...tranObj, sharePrice: "", shareQuantity: +monthlyShareQty.toFixed(4)}
    }
    yearBreakArr.push(tranObj);
    
    lastEntry = true;
    insertYearBreakTrans(totalTranAmt, previousTranYear, savingsClass, totalShareQty, 
        tranSort, yearBreakArr, lastEntry);
    const returnObj = {totalTranAmt: totalTranAmt, totalShareQty: totalShareQty, yearBreakArr: yearBreakArr};
    return returnObj;
}

export default calcTotalTranAmts;